import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PromiseBar } from './components/PromiseBar';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { Reels } from './components/Reels';
import { Coverage } from './components/Coverage';
import { Quote } from './components/Quote';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-white font-heading text-ink antialiased" data-id="element-0" data-mp="2mmcb204xiw82">
      <Header data-id="element-1" data-mp="31agnwnhawdix" />
      <main data-id="element-2" data-mp="31ayry6a7fw1e">
        <Hero data-id="element-3" data-mp="31bs0ncsq4vm6" />
        <PromiseBar data-id="element-4" data-mp="31c9w477kb5t1" />
        <Services data-id="element-5" data-mp="31ctflscv2296" />
        <Gallery data-id="element-6" data-mp="2wk0ah3dhcrwk" />
        <Reviews data-id="element-7" data-mp="2wjgptewg3peu" />
        <Reels data-id="element-8" data-mp="2wiyvintcfl9k" />
        <Coverage data-id="element-9" data-mp="2wifgbev2vaz8" />
        <Quote data-id="element-10" data-mp="2whxbhtucnofp" />
      </main>
      <Footer data-id="element-11" data-mp="28u5zysgmvffh" />
    </div>;
}